"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a class enrollment filed failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */
class ClassEnrollmentBodyNotValidError extends client_library_1.ExtendableError {
    constructor(field, message) {
        super(`class enrollment: ${field} failed validation. ${message}`);
        this.field = field;
    }
}
exports.default = ClassEnrollmentBodyNotValidError;
//# sourceMappingURL=ClassEnrollmentBodyNotValidError.js.map